import { ChangeDetectorRef, Component, ElementRef, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators, DefaultValueAccessor } from '@angular/forms';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ActivatedRoute, Router } from '@angular/router';
import { UserManagerService } from '../shared/providers/user-manager.service';
import { LoaderService } from '../shared/providers/loader.service';
import { CommonService } from '../shared/providers/common.service';
import { ValidationService } from '../shared/providers/validation.service';
import { IBuyerQuestionsModel } from '../shared/models/BuyerQuestionsModel';
import { OfferService } from '../shared/providers/offer.service';
import { AuthenticationService } from '../shared/auth/authentication.service';
import { ToastService } from '../shared/providers/toast.service';

@Component({
  selector: 'app-Buyer-Questionnaire',
  templateUrl: './Buyer-Questionnaire.component.html',
  styleUrls: ['./Buyer-Questionnaire.component.css']
})
export class BuyerQuestionnaireComponent implements OnInit {

  constructor(private activatedRoute: ActivatedRoute, private _offerService: OfferService, private _toastService: ToastService, private cdRef: ChangeDetectorRef, private userManagerService: UserManagerService, private loaderService: LoaderService, private _commonService: CommonService, public Validation: ValidationService, public authService: AuthenticationService, private router: Router) {

  }
  @Input() modalBuyerRef: BsModalRef;
  @Input() PropertyId: number = 0;
  @Input() OfferId: number = 0;
  @Input() source: string = '';
  @Input() PropertyGuid : string = '';
  @Input() submitLOIConfirmationMessage: string;
  @Input() IsHavePermission: number = 0;
  @Input() sourceUrl: string = '';
  currentOfferId: number = 0;
  attendedCount: number = 0;
  user: any;
  activeDiv: number = 1;
  IsfromPlaceOffer: boolean = false;
  haveaccess: boolean = false;
  IsHaveRemainder: number = 0;
  BuyerQuestionsModel = {} as IBuyerQuestionsModel;
  ngOnInit(): void {
    this.user = this.user = this.authService.user;
    this.BuyerQuestionsModel.PropertyId = this.PropertyId;
    this.BuyerQuestionsModel.OfferId = this.OfferId;
    if (this.source == 'PlaceOffer' && this.submitLOIConfirmationMessage != null && this.submitLOIConfirmationMessage != '') {
      this.IsfromPlaceOffer = true;
    }
    this.LoadBuyerAnswers();
  }

  LoadBuyerAnswers() {
    const Data = {
      UserId: this.user.Id,
      OfferId: this.OfferId,
      Source: this.source
    }
    this._offerService.GetBuyerQuestionnaireDetails(Data).subscribe(response => {
      if (response != null && response.length > 0) {
        this.BuyerQuestionsModel = response[0];
        if (this.BuyerQuestionsModel != null) {
          if (this.BuyerQuestionsModel.IsHaveEditingPermission != null) {
            this.IsHavePermission = this.BuyerQuestionsModel.IsHaveEditingPermission;
          }
          if (this.BuyerQuestionsModel.OfferId != null) {
            this.currentOfferId = this.BuyerQuestionsModel.OfferId;
          }
          if (this.BuyerQuestionsModel.IsHaveremainderPermission != null) {
            this.IsHaveRemainder = this.BuyerQuestionsModel.IsHaveremainderPermission;
          }
          if (this.authService.IsUserRole(this.authService.UserRole.Broker) && this.source != 'PlaceOffer') {
            this.haveaccess = true;
          }
        }
        this.getcount();
      }
      if (this.source == 'PlaceOffer') {
        this.IsHavePermission = 1;
      }
    });
  }

  GetNextQuestions(source: string) {
    this.IsfromPlaceOffer = false;
    if (source == 'Back') {
      this.activeDiv = this.activeDiv - 1;
    }
    else {
      this.activeDiv = this.activeDiv + 1;
    }
    this.getcount();
    
  }

  OnCancel() {
    this.modalBuyerRef.hide();
  }

  Save(source: string) {
    let message = '';
    if (this.BuyerQuestionsModel != null && this.PropertyId != null && this.OfferId != null) {
      if (this.source == 'PlaceOffer') {
        this.BuyerQuestionsModel.Source = 'LeadOffer';
      }
      else {
        this.BuyerQuestionsModel.Source = 'LeadDetail';
      }
      this.BuyerQuestionsModel.LoggedInUserId = this.user.Id;
      this.BuyerQuestionsModel.PropertyId = this.PropertyId;
      this.BuyerQuestionsModel.OfferId = this.OfferId;
      if (source =='SaveLater') {
        this.BuyerQuestionsModel.IsDraft = true;
        message = 'Buyer Questionnaire Saved to Draft Successfully';
      }
      else {
        this.BuyerQuestionsModel.IsDraft = false;
        message = 'Buyer Questionnaire Saved Successfully';
      }
      this._offerService.SaveBuyerQuestionnaire(this.BuyerQuestionsModel).subscribe(response => {
        if (response) {
          this._toastService.addToast({ title: 'Success', msg: message, timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });
          this.onRedirection();

        }
        else {
          this._toastService.addToast({ title: 'Error Occurred', msg: "Error occured", timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
          this.onRedirection();
        }
      });
    }

  }

  getcount() {
    let values = [];
    values.push(this.BuyerQuestionsModel);
    values = values.map(item => {
      delete item.PropertyId;
      delete item.OfferId;
      if (item.IsDraft != undefined) {
        delete item.IsDraft;
      }
      if (item.LoggedInUserId != undefined) {
        delete item.LoggedInUserId;
      }
      if (item.Id != undefined) {
        delete item.Id;
      }
      if (item.IsHaveremainderPermission != undefined) {
        delete item.IsHaveremainderPermission;
      }
      if (item.IsHaveEditingPermission != undefined) {
        delete item.IsHaveEditingPermission;
      }
      if (item.Source != undefined) {
        delete item.Source;
      }
      return item;
    });
    let count = 0;
    Object.values(values[0]).forEach(item => {
      if (item != null && item!='') {
        count = count + 1;
      }
    });
    this.attendedCount = count;
  }

  onRedirection() {
    let redirectionLink = '';
    if (this.PropertyGuid != null && this.PropertyGuid != undefined && this.PropertyGuid != '') {
      redirectionLink = "/viewproperty/" + this.PropertyGuid;
    }
    else if (this.source == 'OfferList') {
      if (this.authService.Principal() || this.authService.Principal1031()) {
        redirectionLink = '/deals-buy';
      }
      else {
        redirectionLink = '/offers-placed';
      }
    }
    else if (this.source == 'OfferPlaced') {
      if (this.sourceUrl != null && this.sourceUrl != '') {
        redirectionLink = this.sourceUrl;

      }
      else {
        redirectionLink = '/placed-offers';

      }
    }
    if (redirectionLink != '') {
      this.modalBuyerRef.hide();
      window.scrollTo(0, 0);
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
        this.router.navigateByUrl(redirectionLink));
    }
    else {
      this.modalBuyerRef.hide();
      window.scrollTo(0, 0);
    }
    
  }

  SendRemainder() {
    this._offerService.SendBuyerQuestionsRemainder(this.currentOfferId, this.user.Id).subscribe(response => {
      if (response) {
        this._toastService.addToast({ title: 'Success', msg: "Reminder sent successfully", timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });
     }
      else {
        this._toastService.addToast({ title: 'Error Occurred', msg: "Error occured", timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
      }
    });
  }
}
